<div class="ng-footer">
    <div>Aurora Health | Version : {{version}}</div>
</div>